import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-landing-home-footer',
  templateUrl: './landing-home-footer.component.html',
  styleUrls: ['./landing-home-footer.component.scss']
})
export class LandingHomeFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
